module.exports = __webpack_public_path__ + "static/img/nav_bg2.1676f400.png";